import { usePage } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import React from 'react'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import useBlogData from '../../hooks/useBlogData'
import { ActivePopup } from '../components/popup/active-popup'
import PageUi from '../ui/PageUi'

function BlogPage({ children }: { children: React.ReactNode }) {
  useBlogData()
  const { globalFontFamily, globalFontStyle, globalFontWeight } =
    useCalculateTypography({})

  return (
    <PageUi
      fontFamily={globalFontFamily}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

export default BlogPage
